import { INDIAN_STATES } from "../data/indianStates";

/**
 * State dropdown storing the standard 2-letter state code (e.g. "KA" for Karnataka, "TG" for Telangana) —
 * the same style already used across this app's existing customer/distributor records.
 *
 * `onStateSelect(state)` — optional — fires with the full matched state object ({ name, code, gstCode })
 * whenever a real state is picked, so the parent form can do something extra with it (e.g. auto-fill the
 * leading digits of a GSTIN field with `gstCode`) without that logic living inside this shared component.
 */
const StateSelect = ({ name = "stateCode", value, onChange, onStateSelect, required }) => {
  // Older records may have a value that doesn't match our list (a typo, a different convention) —
  // keep it selectable instead of silently blanking the field out when editing them.
  const currentIsKnown = INDIAN_STATES.some((s) => s.code === value);
  const legacyValue = value && !currentIsKnown ? value : null;

  const handleChange = (e) => {
    onChange(e);
    if (onStateSelect) {
      const state = INDIAN_STATES.find((s) => s.code === e.target.value);
      if (state) onStateSelect(state);
    }
  };

  return (
    <select name={name} value={value || ""} onChange={handleChange} required={required}>
      <option value="">Select state</option>
      {legacyValue ? <option value={legacyValue}>{legacyValue} (existing value)</option> : null}
      {INDIAN_STATES.map((s) => (
        <option key={s.code} value={s.code}>
          {s.name} ({s.code})
        </option>
      ))}
    </select>
  );
};

export default StateSelect;
